// Manages: households/{householdId}/budget (budgets field)
import { write } from '@/lib/firebase';

const budgetPath = (householdId) => `households/${householdId}/budget`;

export const budgetService = {
  async saveBudget(householdId, data, budgetKey, currentBudgets, cat, value) {
    const updated = { ...currentBudgets, [cat]: parseFloat(value) || 0 };
    await write(budgetPath(householdId), { ...data, budgets: { ...data.budgets, [budgetKey]: updated } });
  },

  async copyBudgetEntire(householdId, data, budgetKey, sourceKey) {
    const source = data.budgets[sourceKey] || {};
    if (Object.keys(source).length === 0) return;
    await write(budgetPath(householdId), { ...data, budgets: { ...data.budgets, [budgetKey]: { ...source } } });
  },

  async copyBudgetCategory(householdId, data, budgetKey, sourceKey, currentBudgets, expenseItems) {
    const source = data.budgets[sourceKey] || {};
    if (Object.keys(source).length === 0) return;
    const merged = { ...currentBudgets };
    expenseItems.forEach(cat => {
      if (source[cat] !== undefined) merged[cat] = source[cat];
    });
    await write(budgetPath(householdId), { ...data, budgets: { ...data.budgets, [budgetKey]: merged } });
  },
};
